import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import JobsBoardBannerAd from 'components/Ads/JobsBoardBanner/JobsBoardBannerAd';
import Loader from 'components/Loader/Loader';

const JobsBoardBanner = ({ partners, loadedPartners, loadingPartners }) => {
  const [advert, setAdvert] = useState(null);

  useEffect(() => {
    if (loadedPartners) {
      getAdvert();
    }
  }, [loadedPartners]);

  const getAdvert = () => {
    //set initial random index before changing array based on location
    const randomNumber = Math.floor(Math.random() * partners.length);

    setAdvert(partners.length > 0 ? partners[randomNumber] : null);
  };

  return loadingPartners ? (
    <Loader loading />
  ) : (
    <JobsBoardBannerAd advert={advert} />
  );
};

JobsBoardBanner.propTypes = {
  partners: PropTypes.array,
  loadedPartners: PropTypes.bool,
  loadingPartners: PropTypes.bool,
};

export default React.memo(JobsBoardBanner);
